const FontsSVG = ({ fill, stroke }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 28 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon" clip-path="url(#clip0_3424_12964)">
        <path
          id="Vector"
          d="M26.4444 0H1.55556C1.143 0 0.747335 0.163889 0.455612 0.455612C0.163888 0.747335 0 1.143 0 1.55556V6.22222C0 6.63478 0.163888 7.03044 0.455612 7.32217C0.747335 7.61389 1.143 7.77778 1.55556 7.77778C1.96811 7.77778 2.36378 7.61389 2.6555 7.32217C2.94722 7.03044 3.11111 6.63478 3.11111 6.22222V3.11111H12.4444V23.3333H9.33333C8.92077 23.3333 8.52511 23.4972 8.23339 23.7889C7.94167 24.0807 7.77778 24.4763 7.77778 24.8889C7.77778 25.3014 7.94167 25.6971 8.23339 25.9888C8.52511 26.2806 8.92077 26.4444 9.33333 26.4444H18.6667C19.0792 26.4444 19.4749 26.2806 19.7666 25.9888C20.0583 25.6971 20.2222 25.3014 20.2222 24.8889C20.2222 24.4763 20.0583 24.0807 19.7666 23.7889C19.4749 23.4972 19.0792 23.3333 18.6667 23.3333H15.5556V3.11111H24.8889V6.22222C24.8889 6.63478 25.0528 7.03044 25.3445 7.32217C25.6362 7.61389 26.0319 7.77778 26.4444 7.77778C26.857 7.77778 27.2527 7.61389 27.5444 7.32217C27.8361 7.03044 28 6.63478 28 6.22222V1.55556C28 1.143 27.8361 0.747335 27.5444 0.455612C27.2527 0.163889 26.857 0 26.4444 0Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3424_12964">
          <rect width="28" height="28" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FontsSVG
